import { logger } from '@/lib/logger';

type AnalyticsPayload = Record<string, unknown> | undefined;

declare global {
  interface Window {
    analytics?: {
      track?: (event: string, payload?: AnalyticsPayload) => void;
    };
  }
}

class AnalyticsService {
  track(event: string, payload?: AnalyticsPayload) {
    try {
      if (typeof window !== 'undefined' && window.analytics?.track) {
        window.analytics.track(event, payload);
        return;
      }
    } catch (error) {
      logger.warn('Analytics tracking failed, falling back to console.', error);
    }

    if (payload) {
      logger.info(`[analytics] ${event}`, payload);
    } else {
      logger.info(`[analytics] ${event}`);
    }
  }
}

export const analyticsService = new AnalyticsService();
